import React from 'react';
import './TimelineProcessViewLegend.scss';

const TimelineProcessViewLegend = () => {
    return (
        <div className="tooltip-legend">
            <div className="tooltip-legend-item completed">
                <span className="legend-indicator"></span>
                <span>Completed event</span>
            </div>
            <div className="tooltip-legend-item late">
                <span className="legend-indicator"></span>
                <span>Late event</span>
            </div>
            <div className="tooltip-legend-item in-progress">
                <span className="legend-indicator"></span>
                <span>In Progress event</span>
            </div>
            <div className="tooltip-legend-item upcoming">
                <span className="legend-indicator"></span>
                <span>Upcoming event</span>
            </div>
        </div>
    );
};

export default TimelineProcessViewLegend;
